import { FIELD_FILE } from 'config/app'

export const { fields, defaults } = require(`assets/json/${FIELD_FILE}`)

export const fieldLabels = fields.map((f) => f.label)

export const fieldNames = fields.map((f) => f.name)
